export default {
  // Config
 apiKey: "AIzaSyCrnkelnBihHtodtm91lpcUUSccG2lf6Ak",
  authDomain: "hyroad-mytrace.firebaseapp.com",
  projectId: "hyroad-mytrace",
  storageBucket: "hyroad-mytrace.firebasestorage.app",
  messagingSenderId: "462427382055",
  appId: "1:462427382055:web:242e065f8e38659b2a8902"
};
